const PARTNER_BANK_DETAILS = {
  invalidAccount: 'Não foi possível validar sua conta.',
  dataChangeInfo:
    'Entre em contato pelo chat para alterar a Razão Social e/ou o CNPJ',
  accountData: 'Dados da conta',
  doDataValidation: 'Enviar dados',
  partnerInfoRegisteredAtTheBank: 'Dados do favorecido cadastrado no banco',
  partnerInfo: 'Dados do favorecido',
  bankData: 'Dados bancários',
  tradingName: 'Razão social',
  document: 'CNPJ',
  bank: 'Banco',
  bankSearchPlaceholder: 'Buscar banco',
  accountType: 'Tipo de conta',
  agency: 'Agência',
  optionalDigit: 'Dígito (opcional)',
  account: 'Conta',
  digit: 'Dígito',
  agencyDigit: 'Dígito da agência',
  accountDigit: 'Dígito da conta',
  registrationSummary: 'Resumo do cadastro',
  confirm: 'Confirmar',
  goBack: 'Voltar',
  cancel: 'Cancelar',
  accountStatusError:
    'Conta inválida. Revise os dados bancários ou entre em contato com o responsável do banco para mais informações.',
  accountStatusUpdateAccount:
    'Você poderá editar os dados bancários a partir de ',
  statuses: {
    pending: 'Aguardando aprovação em até 24h úteis',
    invalid: 'Erro - Edite suas informações',
  },
  registerAccountInfo:
    'Cadastre seus dados bancários para receber seus pagamentos por transferência sem custo.',
  register: 'Cadastrar',
  toEditYourDataContactUs: 'Para editar seus dados entre em contato via chat',
  edit: 'Editar dados',
  genericError: 'Houve um erro, tente novamente mais tarde',
  documentError: 'Erro - CNPJ pendente',
  documentExplanation:
    'Cadastre seus dados bancários para receber seus pagamentos por transferência sem custo.',
  documentRegistration: 'Para cadastrar o seu CNPJ entre em contato via chat',
}

export default PARTNER_BANK_DETAILS
